"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "createMuiTheme", {
  enumerable: true,
  get: function get() {
    return _createTheme["default"];
  }
});
Object.defineProperty(exports, "tokens", {
  enumerable: true,
  get: function get() {
    return _tokens["default"];
  }
});
exports["default"] = exports.ThemeProvider = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _createTheme = _interopRequireDefault(require("./createTheme"));

var _tokens = _interopRequireDefault(require("./theme/tokens"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var defaultTheme = (0, _createTheme["default"])();

var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
      theme = _ref.theme;
  return /*#__PURE__*/_react["default"].createElement(_styles.ThemeProvider, {
    theme: theme
  }, children);
};

exports.ThemeProvider = ThemeProvider;
ThemeProvider.defaultProps = {
  theme: defaultTheme
};
/**
 * @deprecated since version 0.0.2
 */

var _default = defaultTheme;
exports["default"] = _default;